import { urlConfig } from '@config/url.config';
import AbstractAPI from './Abstract.api';

export interface IRights {
    send_commands: boolean;
    change_settings: boolean;
}

interface IRemoveDeviceReq {
    token: string;
    login: string;
    imei: string;
}

interface IGetRightsReq extends IRemoveDeviceReq {}

interface IGerRightsRes {
    rights: IRights;
}

interface IAddDeviceReq extends IRemoveDeviceReq, IGerRightsRes {}

interface IGetSubusersRes {
    subusers: string[];
}

interface IGetDevicesRes {
    devices: string[];
}

export class SubuserAPI extends AbstractAPI {
    async getSubusers(token: string) {
        const pathname = 'subuser/get';
        const method = 'POST';
        const body = {
            token,
        };
        try {
            return await this._request<IGetSubusersRes>(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async create(token: string, login: string, password: string) {
        const pathname = 'subuser/create';
        const method = 'POST';
        const body = {
            token,
            login,
            password,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async changePassword(token: string, login: string, password: string) {
        const pathname = 'subuser/change_password';
        const method = 'POST';
        const body = {
            token,
            login,
            password,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async delete(token: string, login: string) {
        const pathname = 'subuser/delete';
        const method = 'POST';
        const body = {
            token,
            login,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async getDevices(token: string, login: string) {
        const pathname = 'subuser/get_devices';
        const method = 'POST';
        const body = {
            token,
            login,
        };
        try {
            return await this._request<IGetDevicesRes>(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async addDevice({ token, login, imei, rights }: IAddDeviceReq) {
        const pathname = 'subuser/add_device';
        const method = 'POST';
        const body = {
            token,
            login,
            imei,
            rights,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async removeDevice({ token, login, imei }: IRemoveDeviceReq) {
        const pathname = 'subuser/remove_device';
        const method = 'POST';
        const body = {
            token,
            login,
            imei,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async getRights({ token, login, imei }: IGetRightsReq) {
        const pathname = 'subuser/get_rights';
        const method = 'POST';
        const body = {
            token,
            login,
            imei,
        };
        try {
            return await this._request<IGerRightsRes>(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
    async changeRights({ token, login, imei, rights }: IAddDeviceReq) {
        const pathname = 'subuser/change_rights';
        const method = 'POST';
        const body = {
            token,
            login,
            imei,
            rights,
        };
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
}

export const subuserAPI = new SubuserAPI(urlConfig);
